import type { Dtos, FeatureFlagName } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { featureFlagsQueryKey } from "./feature-flags.keys";

export const useUpdateFeatureFlag = () => {
	const queryClient = useQueryClient();
	const { patch } = useRequest();

	const mutation = useMutation({
		mutationFn: async ({ name, enabled }: { name: FeatureFlagName; enabled: boolean }) =>
			await patch<Dtos.FeatureFlag.Update.Response>(`/v2/admin/feature-flags/${name}`, { enabled }),
		onSettled: async () => {
			await queryClient.invalidateQueries({ queryKey: featureFlagsQueryKey() });
		},
	});

	return {
		updateFeatureFlag: mutation.mutate,
		updateFeatureFlagLoading: mutation.isPending,
		updateFeatureFlagError: mutation.error,
		resetUpdateFeatureFlagError: () => {
			mutation.reset();
		},
	};
};
